import { AlertCircle, CheckCircle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface StepConfigurationStatusProps {
  status: 'pending' | 'completed';
}

export function StepConfigurationStatus({ status }: StepConfigurationStatusProps) {
  if (status === 'completed') {
    return (
      <Badge variant="success-subtle" className="flex items-center gap-1">
        <CheckCircle className="h-3.5 w-3.5" />
        Perfis selecionados para todos os equipamentos
      </Badge>
    );
  }

  return (
    <Badge variant="warning-subtle" className="flex items-center gap-1">
      <AlertCircle className="h-3.5 w-3.5" />
      Configurações pendentes
    </Badge>
  );
}
